import React from 'react'
import { Router } from 'react-router'
import inkContextTypes from 'react-md/lib/Inks/inkContextTypes'
import history from 'shared/utils/history'
import store from 'shared/redux/store'
import { Provider as ReduxProvider } from 'react-redux'
import renderRoutes from 'shared/utils/renderRoutes'
import routes from './routes'
import ToastContainer from 'shared/components/Layout/ToastContainer'
import { GlobalStyle } from 'theme'
import { BreakpointProvider } from 'shared/hooks/useBreakpoint'
import { MenuContextProvider } from 'shared/components/Layout/MenuContext'
import Theme from 'shared/components/Layout/Theme'

class App extends React.Component {
  static childContextTypes = inkContextTypes
  getChildContext() {
    // Any ink interaction is disabled
    return { inkDisabled: true }
  }
  render() {
    return (
      <BreakpointProvider>
        <MenuContextProvider>
          <GlobalStyle />
          <ReduxProvider store={store}>
            <Theme>
              <ToastContainer />
              <Router history={history}>{renderRoutes(routes, {}, {}, true)}</Router>
            </Theme>
          </ReduxProvider>
        </MenuContextProvider>
      </BreakpointProvider>
    )
  }
}

export default App
